module.exports = __webpack_public_path__ + "img/undraw_Mention_re_k5xc.9e8e0867.svg";